<template>
  <div class="sidebar"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage"
       :data-active-color="activeColor">

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="logo">
        <a href="" class="simple-text logo-normal pl-5">
          {{ title }}
        </a>
      </div>
      <slot>

      </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'sidebar',
        props: {
            title: {
                type: String,
                default: 'ADMIN'
            },
            backgroundColor: {
                type: String,
                default: 'black',
                validator: (value) => {
                    let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
                    return acceptedValues.indexOf(value) !== -1
                }
            },
            backgroundImage: {
                type: String,
                default: '/static/img/full-screen-image-8.png'
            },
            activeColor: {
                type: String,
                default: 'success',
                validator: (value) => {
                    let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
                    return acceptedValues.indexOf(value) !== -1
                }
            },
            sidebarLinks: {
                type: Array,
                default: () => []
            },
            autoClose: {
                type: Boolean,
                default: true
            }
        },
        provide() {
            return {
                autoClose: this.autoClose
            }
        },
        computed: {
            sidebarStyle() {
                return {
                    backgroundImage: `url(${this.backgroundImage})`
                }
            }
        },
        methods: {
            async initScrollBarAsync() {
                await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
                const PerfectScroll = await import('perfect-scrollbar')
                PerfectScroll.initialize(this.$refs.sidebarScrollArea)
            }
        },
        mounted() {
            this.initScrollBarAsync()
        },
        beforeDestroy() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.showSidebar = false
            }
        }
    }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu {
      display: none;
    }
  }
</style>
